import React from "react";
import ReactDOM from "react-dom";

import AsyncSelect from "react-select/async";

class MyComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            selectedOption: null,
            drugList: null,
            isLoaded: false,
            data: []};
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
        fetch("https://api.fda.gov/drug/ndc.json?search=pharm_class:\""+selectedOption.value+"\"&limit=100")
            .then (res => res.json())
            .then(result => {
                this.setState({
                    drugList: result.results});
            });
    }
    
    componentDidMount() {
     fetch(`https://api.fda.gov/drug/ndc.json?count=pharm_class.exact&limit=1000`)
      .then(res => res.json())
            .then(result => {
                var j = [];
                for (let term of result.results) {
                    j.push({value: term.term, label: term.term});
                }
                this.setState({
                    isLoaded: true,
                    data: j});
            })};

      loadOptions = inputValue => {
          return new Promise((resolve, reject) => {
      // using setTimeout to emulate a call to server
      setTimeout(() => {
          resolve(this.filter(inputValue));
      }, 2);
    });
      };

    filter = inputValue =>
        this.state.data.filter(option =>
                               option.label.toLowerCase().includes(inputValue.toLowerCase())
                              );

    render() {
        const { error, selectedOption, isLoaded, data } = this.state;
        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            return (
                <div>
                    <AsyncSelect
                defaultOptions
                onChange={this.handleChange}
                cacheOptions
                loadOptions={this.loadOptions}
                />
                {this.state.drugList == null ?
                 <div></div>
                 :
                 <div>{this.state.drugList.map(drug => (
                         <div key={drug.product_ndc}>{drug.generic_name}: {drug.labeler_name}</div>
                 ))}
                 </div>
                }
                </div>
            )
        }
    }
}

ReactDOM.render(<MyComponent />, document.getElementById("app"))
